import {Loader} from '@mantine/core';
import {useEffect, useState} from 'react';
import {GoogleAdBannerName} from '../../../../config/constants/googleAdBanner';
import {cn} from '../../../../lib/classname';
import {useGoogleAdBanner} from '../../../../shared/services/useGoogleAdBanner';
import {addStyleToPostContent} from '../../usecases/addStyleToPostContent';

type Props = {
  parsedContent: string;
  className?: string;
};

export const PostContent: React.FC<Props> = ({
  parsedContent,
  className,
}: Props) => {
  const googleAdBannerNames = [
    GoogleAdBannerName.C_OVER_POST,
    GoogleAdBannerName.C_UNDER_POST,
  ];
  const {setShouldRefetch} = useGoogleAdBanner(googleAdBannerNames);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // DOMにスタイルを追加する前はローディングを表示していたが、SEO的な観点で最初からコンテンツを表示するように変更
    addStyleToPostContent()
      .then((): void => {
        setIsLoading(false);
      })
      .catch((): void => {
        setIsLoading(true);
        throw new Error('Failed to add style to DOM');
      });
    setShouldRefetch(true);
  }, []);

  return (
    <div className={cn(className)}>
      {isLoading && (
        <div className="w-full h-[150px] flex justify-center items-center">
          <Loader color="gray" />
        </div>
      )}
      <div className="max-w-[800px] mx-auto">
        <div
          id="postContent"
          className={`${isLoading ? 'hidden' : ''} text-base text-black-1 leading break-all pt-12`}
          dangerouslySetInnerHTML={{
            __html: parsedContent,
          }}
        />
      </div>
    </div>
  );
};
